import { CheckCircle, Badge } from 'lucide-react';
import { Button } from '@zaogig/ui/button';
import { Card, CardContent } from '@zaogig/ui/card';
import type { CheckOutResultData, TodayAttendanceData } from '../../hooks/use-attendance-state';

interface CheckOutSuccessPhaseProps {
  result: CheckOutResultData;
  todayAttendance: TodayAttendanceData | null;
  onComplete: () => void;
}

export function CheckOutSuccessPhase({
  result,
  todayAttendance,
  onComplete
}: CheckOutSuccessPhaseProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6">
      <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6">
        <CheckCircle className="w-12 h-12 text-green-600" />
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">下班打卡成功</h2>

      <div className="text-center mb-6">
        {result.workMinutes && (
          <p className="text-2xl font-bold text-blue-600">
            工作 {Math.floor(result.workMinutes / 60)}时{result.workMinutes % 60}分
          </p>
        )}
        {result.summaryScore && (
          <Badge className="mt-2">
            总结评分: {result.summaryScore}分
          </Badge>
        )}
      </div>

      {todayAttendance?.estimatedIncome && (
        <Card className="mb-6 w-full">
          <CardContent className="p-4 text-center">
            <p className="text-gray-500 text-sm">预估收入</p>
            <p className="text-2xl font-bold text-green-600">
              ¥{todayAttendance.estimatedIncome.toFixed(2)}
            </p>
          </CardContent>
        </Card>
      )}

      <p className="text-gray-500 text-center mb-8">
        结算单已生成，等待企业确认
      </p>

      <Button
        onClick={onComplete}
        className="w-full bg-blue-600 hover:bg-blue-700"
      >
        完成
      </Button>
    </div>
  );
}
